<template>
    <tr @click="showUserLog">
        <th :class="{ 'bg-warning': $utils.isToday(month, date), }">
            {{ date }}({{ $utils.formatDDD(month, date) }})

            <b-modal
                ref="user_log"
                size="lg"
                :title="$utils.formatYYYYMMDDDDD(month, date)"
                @shown="shown"
                >
                <CalendarInfoDetail
                    :model="model"
                    :date="date"
                    :month="month"
                    :user_log="user_log"
                    @change="toggleUserLog"
                    />
                <template #modal-footer="{ ok, cancel, hide }">
                    <b-button @click="ok()">
                        OK
                    </b-button>
                </template>
            </b-modal>
        </th>

        <td v-for="i of (model.length / 3)">
            <span class="fw-900">{{ trans.labels['bible.book_abbr.' + model[3 * (i - 1) + 0]] }}</span>
            <template v-for="(item, index) in $utils.getUrlsFromCsv(model[3 * (i - 1) + 2])">
                <span class="fw-900">※{{ index + 1 }}</span>&thinsp;
            </template>
            <br>
            <template v-for="(item, index) in $utils.getVersesFromCsv(model[3 * (i - 1) + 1])">
                <span class="fw-900" :class="{ 'text-black-20': !keyForLogOn(date, i - 1, 'v', index) }">{{ trans_p('labels', 'calendar.chapter', { num: item, }) }}</span>&thinsp;
            </template>
            &thinsp;
        </td>
    </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import LinkPrevue from 'link-prevue'
import CalendarInfoDetail from '@/components/CalendarInfoDetail.vue'

import { getLinkPreview, getPreviewFromContent } from "link-preview-js"
//const linkPreviewGenerator = require("link-preview-generator")

export default {
    components: {
        LinkPrevue,
        CalendarInfoDetail,
    },
    props: {
        model: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        date: {
            type: Number,
            required: true,
            default() {
                return 0
            },
        },
        month: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        user_log: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            preview: {},
        }
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'auth_check',
            'trans',
            'trans_p',
        ])
    },
    async mounted() {},
    methods: {
        showUserLog () {
            this.$refs.user_log.show()
        },
        toggleUserLog (key) {
            this.$emit('change', key)
        },
        async shown () {
            if (!Array.isArray(this.model)) {
                return
            }
            this.preview = {}
            for (let i = 0; i < this.model.length / 3; i++) {
                let urls = this.$utils.getUrlsFromCsv(this.model[3 * i + 2])
            }
        },
        keyForLogOn (date, course, type, index) {
            let key = this.$utils.keyForLog(date, course, type, index)
            return this.user_log[key]
        },
    },
}
</script>

<style lang="scss" scoped>
tr {
    cursor: pointer;
}
</style>

